const ACTION_TYPES = {
    decline: 'decline',
    assignToSelf: 'assign_self',
    assignToOther: 'assign_other',
    formHistory: 'form_history',
    withdraw: 'withdraw',
    split_application: 'split_application',
    view_risks: 'view_risks',
};

export { ACTION_TYPES };
